import React from 'react';
import PropTypes from 'prop-types';

export default function InfoMessage({
  messageBeforeLink,
  messageAfterLink,
  action,
  actionUrl = 'Action',
}) {
  return (
    <span>
      {messageBeforeLink}
      {action && <a onClick={action}>{actionUrl}</a>}
      {messageAfterLink}
    </span>
  );
}

InfoMessage.propTypes = {
  messageBeforeLink: PropTypes.string,
  messageAfterLink: PropTypes.string,
  action: PropTypes.func,
  actionUrl: PropTypes.string,
};
